import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { playerRulesStore } from "../stores/playerRules";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { playerRulesAddModalStore } from "../stores/playerRulesAddModal";
import { playerRulesEditModalStore } from "../stores/playerRulesEditModal";

/* ------- */

class PlayerRules extends React.Component {
	constructor(props) {
		super(props);
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadPlayerRulesList();
			}, 0);
		}
	};

	handleInputDebounceChange = (input, type) => {
		this.props.setPlayerRules({
			...this.props.playerRules,
			currentSearch: input.detail.value,
			pagination: {
				...this.props.playerRules.pagination,
				current: 1,
			}
		});

		if (input.detail.value.length === 0) {
			setTimeout(() => this.props.Interface.loadplayerRulesList(), 250)
		}
	};

	
	componentDidMount() {
		this.props.Interface.loadPlayerRulesList();
	}



	render() {
		return (
			<>
				{this.props.playerRules.loaded && this.props.playerRules.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.playerRules.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.playerRules.error.code} | request timestamp: {this.props.playerRules.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.playerRules.loaded}
					sortingColumn={{ sortingField: this.props.playerRules.sorting.sortingColumn.column }}
					sortingDescending={this.props.playerRules.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setPlayerRules({ ...this.props.playerRules, sorting: {
								...this.props.playerRules.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadPlayerRulesList();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										this.props.setPlayerRulesEditModal({
											...this.props.playerRulesEditModal,
											show: true,
											rule: {
												...item
											}
										})
									}}
									children={item.id}
								/>
							),
						},
						{ id: "name", header: "Name", sortingField: "name", cell: (item) => item.name },
						{ id: "enabled", header: "Enabled", sortingField: "enabled", cell: (item) => item.enabled },
						{ id: "external", header: "External", sortingField: "external", cell: (item) => item.external },
						{
							id: "color", header: "Color", sortingField: "color", cell: (item) => <div
								style={{
									width: "30px",
									height: "30px",
									backgroundColor: item.color || "",
									border: "1px solid #ccc",
								}}
							/>,
						},
						{
							id: "created_at",
							header: "Date",
							sortingField: "created_at",
							cell: (item) => <>{new Date(item.created_at).toLocaleDateString() + " " + new Date(item.created_at).toLocaleTimeString()}</>,
						},
					]}
					items={this.props.playerRules.data}
					pagination={
						<Pagination
							disabled={!this.props.playerRules.loaded}
							currentPageIndex={this.props.playerRules.pagination.current}
							pagesCount={this.props.playerRules.pagination.total}
							onChange={(page) => {
								this.props.setPlayerRules({ ...this.props.playerRules, pagination: { ...this.props.playerRules.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => {
									this.props.Interface.loadPlayerRulesList();
								}, 250)
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Player rules per page", options: this.props.config.playerRules.preferences.perPage }}
							preferences={{ pageSize: this.props.config.playerRules.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("playerRules.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, playerRules: { ...this.props.config.playerRules, perPage: preferences.detail.pageSize } });

								setTimeout(() => {
									this.props.Interface.loadPlayerRulesList();
								}, 250);
							}}
						/>
					}
					header={<Box
						margin={{ bottom: "m" }}
						children={
							<Header
								children="Player rules"
								actions={
									<SpaceBetween direction="horizontal" size="xs">
										<Button
											iconName="add-plus"
											disabled={!this.props.playerRules.loaded}
											variant="primary"
											onClick={() => {
												const { setPlayerRulesAddModal, playerRulesAddModal } = this.props;
												setPlayerRulesAddModal({ ...playerRulesAddModal, show: true });
											}}
										>
											Add player rules
										</Button>
									</SpaceBetween>
								}
								counter={
									<>
										({this.props.playerRules.pagination.count})
									</>
								}
							/>
						}
					/>}
					empty="No playerRules found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const playerRules = useRecoilValue(playerRulesStore);
		const setPlayerRules = useSetRecoilState(playerRulesStore);

		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);

		const playerRulesAddModal = useRecoilValue(playerRulesAddModalStore);
		const setPlayerRulesAddModal = useSetRecoilState(playerRulesAddModalStore);

		const playerRulesEditModal = useRecoilValue(playerRulesEditModalStore);
		const setPlayerRulesEditModal = useSetRecoilState(playerRulesEditModalStore);
		/*
		const playerRules = useRecoilValue(playerRulesStore);
		const setPlayerRules = useSetRecoilState(playerRulesStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const playerModal = useRecoilValue(playerModalStore);
		const setPlayerModal = useSetRecoilState(playerModalStore);

		return <Component {...props} playerRules={playerRules} setPlayerRules={setPlayerRules} config={config} setConfig={setConfig} playerModal={playerModal} setPlayerModal={setPlayerModal} />;
		
		 */

		return <Component {...props} playerRulesEditModal={playerRulesEditModal} setPlayerRulesEditModal={setPlayerRulesEditModal} playerRulesAddModal={playerRulesAddModal} setPlayerRulesAddModal={setPlayerRulesAddModal} config={config} setConfig={setConfig} playerRules={playerRules} setPlayerRules={setPlayerRules} />
	};
}

export default withRecoil(PlayerRules);
